import { render, staticRenderFns } from "./BulkInfrastructureUpgrade.vue?vue&type=template&id=b0d97a70&scoped=true&"
import script from "./BulkInfrastructureUpgrade.vue?vue&type=script&lang=js&"
export * from "./BulkInfrastructureUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d97a70",
  null
  
)

export default component.exports